import {Injectable} from '@angular/core';
import {Crud} from './crud';
import {Observable} from 'rxjs';
import {HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CurdUserprofilService extends Crud {

  getEntity(): Observable<any> {
    const url = '/v1/userprofile';
    return this.http.get(this.serverRoot + url);
  } // getEntity

  getEntities(): Observable<any> {
    const url = '/v1/userprofile';
    return this.http.get(this.serverRoot + url);
  } // getEntities

  updateEntity(id: string = '', entityjson: {}): Observable<any> {
    const url = '/v1/userprofile/' + id;
    const userform = entityjson[0];
    const encryptedCredential = '';
    if (entityjson[1]) {
      const encryptedCredential = entityjson[1];
    }
    const options = {
      headers: new HttpHeaders({cr: encryptedCredential})
    };
    const formData = new FormData();
    formData.append('entity', JSON.stringify(userform));
    return this.http.post(this.serverRoot + url, formData, options);
  } // updateEntity


  //
  //
  // request not used
  createEntity(entityjson: {}): Observable<any> {
    const formData = new FormData();
    formData.append('entity', JSON.stringify(entityjson));
    const url = '/v1/userprofile';
    return this.http.post(this.serverRoot + url, formData);
  } // createEntity

  removeEntity(id: string = ''): Observable<any> {
    const url = '/v1/userprofile/' + id;
    return this.http.delete(this.serverRoot + url);
  } // removeEntity

  getMandantLlanguage() {
    const url = '/v1/mandantlanguage';
    return this.http.get(this.serverRoot + url);
  }

  getFormfield(lngkey: string): Observable<any> {
    const formData = new FormData();
    formData.append('languagekey', lngkey);

    const url = '/v1/userprofileform';
    return this.http.post(this.serverRoot + url, formData);
  }

  getTranslationView(lngkey: string): Observable<any>  {
    const formData = new FormData();
    formData.append('languagekey', lngkey);

    const url = '/v1/userprofileview';
    return this.http.post(this.serverRoot + url, formData);
  }

  getTranslationEdition(lngkey: string, totrsl: {}): Observable<any> {
    const formData = new FormData();
    formData.append('languagekey', lngkey);
    formData.append('totranslate', JSON.stringify(totrsl));

    const url = '/v1/userprofile-edit-translation';
    return this.http.post(this.serverRoot + url, formData);
  }
}



